<template>
  <div class="home1">
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <Single-Profile :json="json" />
  </div>
</template>

<script>
// @ is an alias to /src
import SingleProfile from '@/components/linkedin/SingleProfile/SingleProfile.vue'
import {
  setCookie,
  readCookie,
  postDomChangeAlert
} from '@/assets/util/commonUtil'
// import { MxEvent } from '@/assets/util/constants/analytics'
// import sharedFunctions from '@/assets/util/functions.js'
import { singleParser } from '../domParser/parser'
import { LI_PARSER_ERROR } from '@/assets/util/constants/constants'
export default {
  name: 'SingleProfileView',
  components: {
    'Single-Profile': SingleProfile
  },
  data: function() {
    return {
      json: null
    }
  },
  methods: {
    addListenerForMsgFromPlugin() {
      const that = this
      window.addEventListener(
        'message',
        function(ev) {
          if (ev && ev.data && ev.data.type == 'li-single-mode') {
            if (ev.data.data) {
              const data = ev.data.data
              if (
                data.isServerParserEnabled !== undefined &&
                data.isServerParserEnabled === true
              ) {
                const config = {}
                config.htmlText = data.profileHTML ? data.profileHTML : ''
                config.currentUrl = data.currentUrl ? data.currentUrl : ''
                config.isProspectorParser = true
                singleParser(config).then(function(parsedData) {
                  if (
                    parsedData &&
                    parsedData.domReadError !== undefined &&
                    parsedData.domReadError
                  ) {
                    if (readCookie(LI_PARSER_ERROR.SINGLE) == null) {
                      const reportConfig = {
                        html: config.htmlText,
                        liUrl: config.currentUrl,
                        version: 'server-single'
                      }
                      setCookie(LI_PARSER_ERROR.SINGLE, 'true', 0, 1)
                      postDomChangeAlert(reportConfig)
                    }
                  }
                  that.json = parsedData
                })
              } else if (
                data.domReadError !== undefined &&
                data.domReadError === true
              ) {
                const config = {}
                config.htmlText = data.profileHTML ? data.profileHTML : ''
                config.currentUrl = data.currentUrl ? data.currentUrl : ''
                config.isProspectorParser = true
                singleParser(config).then(function(parsedData) {
                  if (
                    parsedData &&
                    parsedData.domReadError !== undefined &&
                    parsedData.domReadError
                  ) {
                    if (readCookie(LI_PARSER_ERROR.SINGLE) == null) {
                      const reportConfig = {
                        html: config.htmlText,
                        liUrl: config.currentUrl,
                        pageUrl: 'single'
                      }
                      setCookie(LI_PARSER_ERROR.SINGLE, 'true', 0, 1)
                      postDomChangeAlert(reportConfig)
                    }
                  }
                  that.json = parsedData
                })
              } else {
                that.json = ev.data.data
              }
            }
          }
        },
        true
      )
    }
  },
  beforeMount: function() {
    this.addListenerForMsgFromPlugin()
  }
}
</script>
